/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:16030";
    }

    /**
     * @return OK
     */
    administration_Users(  cancelToken?: CancelToken | undefined): Promise<UserReturnModel> {
        let url_ = this.baseUrl + "/api/Administration/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdministration_Users(_response);
        });
    }

    protected processAdministration_Users(response: AxiosResponse): Promise<UserReturnModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserReturnModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserReturnModel>(<any>null);
    }

    /**
     * @return OK
     */
    administration_GetUserById(id: string , cancelToken?: CancelToken | undefined): Promise<UserReturnModel> {
        let url_ = this.baseUrl + "/api/Administration/user/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdministration_GetUserById(_response);
        });
    }

    protected processAdministration_GetUserById(response: AxiosResponse): Promise<UserReturnModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserReturnModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserReturnModel>(<any>null);
    }

    /**
     * @return OK
     */
    administration_GetUserByName(username: string , cancelToken?: CancelToken | undefined): Promise<UserReturnModel> {
        let url_ = this.baseUrl + "/api/Administration/user/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdministration_GetUserByName(_response);
        });
    }

    protected processAdministration_GetUserByName(response: AxiosResponse): Promise<UserReturnModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserReturnModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserReturnModel>(<any>null);
    }

    /**
     * @return OK
     */
    administration_SetUserPassword(passwordModel: SetPasswordModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Administration/user/SetUserPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(passwordModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdministration_SetUserPassword(_response);
        });
    }

    protected processAdministration_SetUserPassword(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    authentication_CreateToken(authenticateUserModel: AuthenticateUserModel , cancelToken?: CancelToken | undefined): Promise<AuthorizationTokenInfo> {
        let url_ = this.baseUrl + "/api/Authentication/CreateToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authenticateUserModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthentication_CreateToken(_response);
        });
    }

    protected processAuthentication_CreateToken(response: AxiosResponse): Promise<AuthorizationTokenInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthorizationTokenInfo.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthorizationTokenInfo>(<any>null);
    }

    /**
     * @return OK
     */
    authentication_AuthenticateUser(authenticateUserModel: AuthenticateUserModel , cancelToken?: CancelToken | undefined): Promise<UserDataModel> {
        let url_ = this.baseUrl + "/api/Authentication/AuthenticateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authenticateUserModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthentication_AuthenticateUser(_response);
        });
    }

    protected processAuthentication_AuthenticateUser(response: AxiosResponse): Promise<UserDataModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDataModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDataModel>(<any>null);
    }

    /**
     * @return OK
     */
    authentication_AuthenticateToken(  cancelToken?: CancelToken | undefined): Promise<UserDataModel> {
        let url_ = this.baseUrl + "/api/Authentication/AuthenticateToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthentication_AuthenticateToken(_response);
        });
    }

    protected processAuthentication_AuthenticateToken(response: AxiosResponse): Promise<UserDataModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDataModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDataModel>(<any>null);
    }

    /**
     * @return OK
     */
    authentication_SendResetPasswordToken(emailAddress: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Authentication/SendResetPasswordToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAddress);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthentication_SendResetPasswordToken(_response);
        });
    }

    protected processAuthentication_SendResetPasswordToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    authentication_SendResetPasswordUrl(emailAddress: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Authentication/SendResetPasswordUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailAddress);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthentication_SendResetPasswordUrl(_response);
        });
    }

    protected processAuthentication_SendResetPasswordUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    authentication_ResetPassword(resetPasswordModel: ResetPasswordModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Authentication/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthentication_ResetPassword(_response);
        });
    }

    protected processAuthentication_ResetPassword(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    registration_CompanySignUp(companyRegistrationModel: CompanyRegistrationModel , cancelToken?: CancelToken | undefined): Promise<SendEmailAddressConfirmationModel> {
        let url_ = this.baseUrl + "/api/Registration/RegisterCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(companyRegistrationModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistration_CompanySignUp(_response);
        });
    }

    protected processRegistration_CompanySignUp(response: AxiosResponse): Promise<SendEmailAddressConfirmationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendEmailAddressConfirmationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendEmailAddressConfirmationModel>(<any>null);
    }

    /**
     * @return OK
     */
    registration_IndividualSignUp(individualRegistrationModel: IndividualRegistration , cancelToken?: CancelToken | undefined): Promise<SendEmailAddressConfirmationModel> {
        let url_ = this.baseUrl + "/api/Registration/RegisterIndividual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(individualRegistrationModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistration_IndividualSignUp(_response);
        });
    }

    protected processRegistration_IndividualSignUp(response: AxiosResponse): Promise<SendEmailAddressConfirmationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendEmailAddressConfirmationModel.fromJS(resultData200);
            return result200;
        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SendEmailAddressConfirmationModel.fromJS(resultData201);
            return result201;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendEmailAddressConfirmationModel>(<any>null);
    }

    /**
     * @return OK
     */
    registration_SendEmailAddressConfirmationUrl(model: SendEmailAddressConfirmationModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Registration/SendEmailAddressConfirmationUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistration_SendEmailAddressConfirmationUrl(_response);
        });
    }

    protected processRegistration_SendEmailAddressConfirmationUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    registration_SendEmailAddressConfirmationToken(model: SendEmailAddressConfirmationModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Registration/SendEmailAddressConfirmationToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistration_SendEmailAddressConfirmationToken(_response);
        });
    }

    protected processRegistration_SendEmailAddressConfirmationToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param code (optional) 
     * @return OK
     */
    registration_ConfirmEmail(userId: string | null | undefined, code: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Registration/ConfirmEmail?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistration_ConfirmEmail(_response);
        });
    }

    protected processRegistration_ConfirmEmail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("BadRequest", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    registration_ConfirmEmailAddress(model: ConfirmEmailAddressModel , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Registration/ConfirmEmailAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistration_ConfirmEmailAddress(_response);
        });
    }

    protected processRegistration_ConfirmEmailAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("BadRequest", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return OK
     */
    roles_GetRole(id: string , cancelToken?: CancelToken | undefined): Promise<RoleReturnModel> {
        let url_ = this.baseUrl + "/api/roles/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoles_GetRole(_response);
        });
    }

    protected processRoles_GetRole(response: AxiosResponse): Promise<RoleReturnModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleReturnModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleReturnModel>(<any>null);
    }

    /**
     * @return OK
     */
    roles_DeleteRole(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/roles/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoles_DeleteRole(_response);
        });
    }

    protected processRoles_DeleteRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return OK
     */
    roles_GetAllRoles(  cancelToken?: CancelToken | undefined): Promise<RoleReturnModel> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoles_GetAllRoles(_response);
        });
    }

    protected processRoles_GetAllRoles(response: AxiosResponse): Promise<RoleReturnModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleReturnModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleReturnModel>(<any>null);
    }

    /**
     * @return OK
     */
    roles_Create(model: CreateRoleBindingModel , cancelToken?: CancelToken | undefined): Promise<RoleReturnModel> {
        let url_ = this.baseUrl + "/api/roles/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoles_Create(_response);
        });
    }

    protected processRoles_Create(response: AxiosResponse): Promise<RoleReturnModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleReturnModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleReturnModel>(<any>null);
    }

    /**
     * @return OK
     */
    roles_AssignRolesToUser(id: string, rolesToAssign: string[] , cancelToken?: CancelToken | undefined): Promise<RoleReturnModel> {
        let url_ = this.baseUrl + "/api/roles/user/{id}/roles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rolesToAssign);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoles_AssignRolesToUser(_response);
        });
    }

    protected processRoles_AssignRolesToUser(response: AxiosResponse): Promise<RoleReturnModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleReturnModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleReturnModel>(<any>null);
    }

    /**
     * @return OK
     */
    userManagement_ChangePassword(model: ChangePasswordBindingModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/UserManagement/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserManagement_ChangePassword(_response);
        });
    }

    protected processUserManagement_ChangePassword(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    userManagement_GetUserDetails(  cancelToken?: CancelToken | undefined): Promise<EditUserModel> {
        let url_ = this.baseUrl + "/api/UserManagement/GetUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserManagement_GetUserDetails(_response);
        });
    }

    protected processUserManagement_GetUserDetails(response: AxiosResponse): Promise<EditUserModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditUserModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditUserModel>(<any>null);
    }

    /**
     * @return OK
     */
    userManagement_UpdateUserDetails(editUserModel: EditUserModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/UserManagement/UpdateUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editUserModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserManagement_UpdateUserDetails(_response);
        });
    }

    protected processUserManagement_UpdateUserDetails(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    userManagement_GetConsigneeDetails(  cancelToken?: CancelToken | undefined): Promise<IndividualConsigneeReturnModel> {
        let url_ = this.baseUrl + "/api/UserManagement/GetConsigneeDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserManagement_GetConsigneeDetails(_response);
        });
    }

    protected processUserManagement_GetConsigneeDetails(response: AxiosResponse): Promise<IndividualConsigneeReturnModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IndividualConsigneeReturnModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndividualConsigneeReturnModel>(<any>null);
    }

    /**
     * @return OK
     */
    userManagement_UpdateConsigneeDetails(updateModel: IndividualConsigneePartialUpdateModel1 , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserManagement/UpdateConsigneeDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserManagement_UpdateConsigneeDetails(_response);
        });
    }

    protected processUserManagement_UpdateConsigneeDetails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class UserReturnModel implements IUserReturnModel {
    id?: string | undefined;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean | undefined;
    roles?: string[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobileNumber?: string | undefined;

    constructor(data?: IUserReturnModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.userName = _data["UserName"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.emailConfirmed = _data["EmailConfirmed"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.mobileNumber = _data["MobileNumber"];
        }
    }

    static fromJS(data: any): UserReturnModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserReturnModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["UserName"] = this.userName;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["EmailConfirmed"] = this.emailConfirmed;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["MobileNumber"] = this.mobileNumber;
        return data; 
    }

    clone(): UserReturnModel {
        const json = this.toJSON();
        let result = new UserReturnModel();
        result.init(json);
        return result;
    }
}

export interface IUserReturnModel {
    id?: string | undefined;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean | undefined;
    roles?: string[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    mobileNumber?: string | undefined;
}

export class SetPasswordModel implements ISetPasswordModel {
    userId!: string;
    newPassword!: string;
    confirmPassword!: string;
    userName!: string;
    name?: string | undefined;

    constructor(data?: ISetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.newPassword = _data["NewPassword"];
            this.confirmPassword = _data["ConfirmPassword"];
            this.userName = _data["UserName"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): SetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["NewPassword"] = this.newPassword;
        data["ConfirmPassword"] = this.confirmPassword;
        data["UserName"] = this.userName;
        data["Name"] = this.name;
        return data; 
    }

    clone(): SetPasswordModel {
        const json = this.toJSON();
        let result = new SetPasswordModel();
        result.init(json);
        return result;
    }
}

export interface ISetPasswordModel {
    userId: string;
    newPassword: string;
    confirmPassword: string;
    userName: string;
    name?: string | undefined;
}

export class AuthenticateUserModel implements IAuthenticateUserModel {
    userName!: string;
    password!: string;

    constructor(data?: IAuthenticateUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): AuthenticateUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        return data; 
    }

    clone(): AuthenticateUserModel {
        const json = this.toJSON();
        let result = new AuthenticateUserModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateUserModel {
    userName: string;
    password: string;
}

export class AuthorizationTokenInfo implements IAuthorizationTokenInfo {
    authorizationToken?: string | undefined;
    authorizationInfo?: UserAuthorizationInfo | undefined;

    constructor(data?: IAuthorizationTokenInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.authorizationInfo = data.authorizationInfo && !(<any>data.authorizationInfo).toJSON ? new UserAuthorizationInfo(data.authorizationInfo) : <UserAuthorizationInfo>this.authorizationInfo; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationToken = _data["AuthorizationToken"];
            this.authorizationInfo = _data["AuthorizationInfo"] ? UserAuthorizationInfo.fromJS(_data["AuthorizationInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthorizationTokenInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationTokenInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AuthorizationToken"] = this.authorizationToken;
        data["AuthorizationInfo"] = this.authorizationInfo ? this.authorizationInfo.toJSON() : <any>undefined;
        return data; 
    }

    clone(): AuthorizationTokenInfo {
        const json = this.toJSON();
        let result = new AuthorizationTokenInfo();
        result.init(json);
        return result;
    }
}

export interface IAuthorizationTokenInfo {
    authorizationToken?: string | undefined;
    authorizationInfo?: IUserAuthorizationInfo | undefined;
}

export class UserAuthorizationInfo implements IUserAuthorizationInfo {
    userId?: string | undefined;
    userName?: string | undefined;
    expiryDate?: string | undefined;
    roles?: string[] | undefined;
    lifetimeInMinutes?: number | undefined;

    constructor(data?: IUserAuthorizationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.userName = _data["UserName"];
            this.expiryDate = _data["ExpiryDate"];
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
            this.lifetimeInMinutes = _data["LifetimeInMinutes"];
        }
    }

    static fromJS(data: any): UserAuthorizationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthorizationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["UserName"] = this.userName;
        data["ExpiryDate"] = this.expiryDate;
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["LifetimeInMinutes"] = this.lifetimeInMinutes;
        return data; 
    }

    clone(): UserAuthorizationInfo {
        const json = this.toJSON();
        let result = new UserAuthorizationInfo();
        result.init(json);
        return result;
    }
}

export interface IUserAuthorizationInfo {
    userId?: string | undefined;
    userName?: string | undefined;
    expiryDate?: string | undefined;
    roles?: string[] | undefined;
    lifetimeInMinutes?: number | undefined;
}

export class UserDataModel implements IUserDataModel {
    isAuthenticated?: boolean | undefined;
    authorizationToken?: string | undefined;
    authorizationInfo?: UserAuthorizationInfo | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    fullName?: string | undefined;
    mobileNumber?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    customerNames?: string[] | undefined;
    roles?: string[] | undefined;
    customerCode?: string | undefined;

    constructor(data?: IUserDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.authorizationInfo = data.authorizationInfo && !(<any>data.authorizationInfo).toJSON ? new UserAuthorizationInfo(data.authorizationInfo) : <UserAuthorizationInfo>this.authorizationInfo; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["IsAuthenticated"];
            this.authorizationToken = _data["AuthorizationToken"];
            this.authorizationInfo = _data["AuthorizationInfo"] ? UserAuthorizationInfo.fromJS(_data["AuthorizationInfo"]) : <any>undefined;
            this.userId = _data["UserId"];
            this.userName = _data["UserName"];
            this.fullName = _data["FullName"];
            this.mobileNumber = _data["MobileNumber"];
            this.email = _data["Email"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            if (Array.isArray(_data["CustomerNames"])) {
                this.customerNames = [] as any;
                for (let item of _data["CustomerNames"])
                    this.customerNames!.push(item);
            }
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
            this.customerCode = _data["CustomerCode"];
        }
    }

    static fromJS(data: any): UserDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsAuthenticated"] = this.isAuthenticated;
        data["AuthorizationToken"] = this.authorizationToken;
        data["AuthorizationInfo"] = this.authorizationInfo ? this.authorizationInfo.toJSON() : <any>undefined;
        data["UserId"] = this.userId;
        data["UserName"] = this.userName;
        data["FullName"] = this.fullName;
        data["MobileNumber"] = this.mobileNumber;
        data["Email"] = this.email;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        if (Array.isArray(this.customerNames)) {
            data["CustomerNames"] = [];
            for (let item of this.customerNames)
                data["CustomerNames"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["CustomerCode"] = this.customerCode;
        return data; 
    }

    clone(): UserDataModel {
        const json = this.toJSON();
        let result = new UserDataModel();
        result.init(json);
        return result;
    }
}

export interface IUserDataModel {
    isAuthenticated?: boolean | undefined;
    authorizationToken?: string | undefined;
    authorizationInfo?: IUserAuthorizationInfo | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    fullName?: string | undefined;
    mobileNumber?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    customerNames?: string[] | undefined;
    roles?: string[] | undefined;
    customerCode?: string | undefined;
}

export class ResetPasswordModel implements IResetPasswordModel {
    emailAddress!: string;
    passwordResetToken!: string;
    password!: string;
    confirmPassword!: string;

    constructor(data?: IResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["EmailAddress"];
            this.passwordResetToken = _data["PasswordResetToken"];
            this.password = _data["Password"];
            this.confirmPassword = _data["ConfirmPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EmailAddress"] = this.emailAddress;
        data["PasswordResetToken"] = this.passwordResetToken;
        data["Password"] = this.password;
        data["ConfirmPassword"] = this.confirmPassword;
        return data; 
    }

    clone(): ResetPasswordModel {
        const json = this.toJSON();
        let result = new ResetPasswordModel();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordModel {
    emailAddress: string;
    passwordResetToken: string;
    password: string;
    confirmPassword: string;
}

export class CompanyRegistrationModel implements ICompanyRegistrationModel {
    primaryUser?: CreateUserBindingModel | undefined;
    company?: CompanyConsigneeBindingModel | undefined;
    emailConfirmationMethod!: CompanyRegistrationModelEmailConfirmationMethod;

    constructor(data?: ICompanyRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.primaryUser = data.primaryUser && !(<any>data.primaryUser).toJSON ? new CreateUserBindingModel(data.primaryUser) : <CreateUserBindingModel>this.primaryUser; 
            this.company = data.company && !(<any>data.company).toJSON ? new CompanyConsigneeBindingModel(data.company) : <CompanyConsigneeBindingModel>this.company; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryUser = _data["PrimaryUser"] ? CreateUserBindingModel.fromJS(_data["PrimaryUser"]) : <any>undefined;
            this.company = _data["Company"] ? CompanyConsigneeBindingModel.fromJS(_data["Company"]) : <any>undefined;
            this.emailConfirmationMethod = _data["EmailConfirmationMethod"];
        }
    }

    static fromJS(data: any): CompanyRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PrimaryUser"] = this.primaryUser ? this.primaryUser.toJSON() : <any>undefined;
        data["Company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["EmailConfirmationMethod"] = this.emailConfirmationMethod;
        return data; 
    }

    clone(): CompanyRegistrationModel {
        const json = this.toJSON();
        let result = new CompanyRegistrationModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyRegistrationModel {
    primaryUser?: ICreateUserBindingModel | undefined;
    company?: ICompanyConsigneeBindingModel | undefined;
    emailConfirmationMethod: CompanyRegistrationModelEmailConfirmationMethod;
}

export class CreateUserBindingModel implements ICreateUserBindingModel {
    email!: string;
    firstName!: string;
    lastName!: string;
    mobileNumber!: string;
    password!: string;
    confirmPassword!: string;

    constructor(data?: ICreateUserBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.mobileNumber = _data["MobileNumber"];
            this.password = _data["Password"];
            this.confirmPassword = _data["ConfirmPassword"];
        }
    }

    static fromJS(data: any): CreateUserBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["MobileNumber"] = this.mobileNumber;
        data["Password"] = this.password;
        data["ConfirmPassword"] = this.confirmPassword;
        return data; 
    }

    clone(): CreateUserBindingModel {
        const json = this.toJSON();
        let result = new CreateUserBindingModel();
        result.init(json);
        return result;
    }
}

export interface ICreateUserBindingModel {
    email: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    password: string;
    confirmPassword: string;
}

export class CompanyConsigneeBindingModel implements ICompanyConsigneeBindingModel {
    companyName!: string;
    companyAddress!: string;
    companyPhone!: string;
    companyEmail!: string;
    companyTRN!: string;

    constructor(data?: ICompanyConsigneeBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["CompanyName"];
            this.companyAddress = _data["CompanyAddress"];
            this.companyPhone = _data["CompanyPhone"];
            this.companyEmail = _data["CompanyEmail"];
            this.companyTRN = _data["CompanyTRN"];
        }
    }

    static fromJS(data: any): CompanyConsigneeBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyConsigneeBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyName"] = this.companyName;
        data["CompanyAddress"] = this.companyAddress;
        data["CompanyPhone"] = this.companyPhone;
        data["CompanyEmail"] = this.companyEmail;
        data["CompanyTRN"] = this.companyTRN;
        return data; 
    }

    clone(): CompanyConsigneeBindingModel {
        const json = this.toJSON();
        let result = new CompanyConsigneeBindingModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyConsigneeBindingModel {
    companyName: string;
    companyAddress: string;
    companyPhone: string;
    companyEmail: string;
    companyTRN: string;
}

export class SendEmailAddressConfirmationModel implements ISendEmailAddressConfirmationModel {
    readonly username?: string | undefined;
    emailAddress!: string;

    constructor(data?: ISendEmailAddressConfirmationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).username = _data["Username"];
            this.emailAddress = _data["EmailAddress"];
        }
    }

    static fromJS(data: any): SendEmailAddressConfirmationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailAddressConfirmationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        data["EmailAddress"] = this.emailAddress;
        return data; 
    }

    clone(): SendEmailAddressConfirmationModel {
        const json = this.toJSON();
        let result = new SendEmailAddressConfirmationModel();
        result.init(json);
        return result;
    }
}

export interface ISendEmailAddressConfirmationModel {
    username?: string | undefined;
    emailAddress: string;
}

export class IndividualRegistration implements IIndividualRegistration {
    customerCode?: string | undefined;
    primaryUser?: CreateUserBindingModel | undefined;
    tRN!: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    parish?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    emailConfirmationMethod!: IndividualRegistrationEmailConfirmationMethod;

    constructor(data?: IIndividualRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.primaryUser = data.primaryUser && !(<any>data.primaryUser).toJSON ? new CreateUserBindingModel(data.primaryUser) : <CreateUserBindingModel>this.primaryUser; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["CustomerCode"];
            this.primaryUser = _data["PrimaryUser"] ? CreateUserBindingModel.fromJS(_data["PrimaryUser"]) : <any>undefined;
            this.tRN = _data["TRN"];
            this.addressLine1 = _data["AddressLine1"];
            this.addressLine2 = _data["AddressLine2"];
            this.addressLine3 = _data["AddressLine3"];
            this.parish = _data["Parish"];
            this.postalCode = _data["PostalCode"];
            this.country = _data["Country"];
            this.emailConfirmationMethod = _data["EmailConfirmationMethod"];
        }
    }

    static fromJS(data: any): IndividualRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerCode"] = this.customerCode;
        data["PrimaryUser"] = this.primaryUser ? this.primaryUser.toJSON() : <any>undefined;
        data["TRN"] = this.tRN;
        data["AddressLine1"] = this.addressLine1;
        data["AddressLine2"] = this.addressLine2;
        data["AddressLine3"] = this.addressLine3;
        data["Parish"] = this.parish;
        data["PostalCode"] = this.postalCode;
        data["Country"] = this.country;
        data["EmailConfirmationMethod"] = this.emailConfirmationMethod;
        return data; 
    }

    clone(): IndividualRegistration {
        const json = this.toJSON();
        let result = new IndividualRegistration();
        result.init(json);
        return result;
    }
}

export interface IIndividualRegistration {
    customerCode?: string | undefined;
    primaryUser?: ICreateUserBindingModel | undefined;
    tRN: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    parish?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    emailConfirmationMethod: IndividualRegistrationEmailConfirmationMethod;
}

export class ErrorResultModel implements IErrorResultModel {
    message?: string | undefined;
    modelSate?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"];
            if (_data["ModelSate"]) {
                this.modelSate = {} as any;
                for (let key in _data["ModelSate"]) {
                    if (_data["ModelSate"].hasOwnProperty(key))
                        this.modelSate![key] = _data["ModelSate"][key] !== undefined ? _data["ModelSate"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message;
        if (this.modelSate) {
            data["ModelSate"] = {};
            for (let key in this.modelSate) {
                if (this.modelSate.hasOwnProperty(key))
                    data["ModelSate"][key] = this.modelSate[key];
            }
        }
        return data; 
    }

    clone(): ErrorResultModel {
        const json = this.toJSON();
        let result = new ErrorResultModel();
        result.init(json);
        return result;
    }
}

export interface IErrorResultModel {
    message?: string | undefined;
    modelSate?: { [key: string]: string[]; } | undefined;
}

export class ConfirmEmailAddressModel implements IConfirmEmailAddressModel {
    username!: string;
    code!: string;

    constructor(data?: IConfirmEmailAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["Username"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): ConfirmEmailAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        data["Code"] = this.code;
        return data; 
    }

    clone(): ConfirmEmailAddressModel {
        const json = this.toJSON();
        let result = new ConfirmEmailAddressModel();
        result.init(json);
        return result;
    }
}

export interface IConfirmEmailAddressModel {
    username: string;
    code: string;
}

export class RoleReturnModel implements IRoleReturnModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IRoleReturnModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): RoleReturnModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleReturnModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data; 
    }

    clone(): RoleReturnModel {
        const json = this.toJSON();
        let result = new RoleReturnModel();
        result.init(json);
        return result;
    }
}

export interface IRoleReturnModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class CreateRoleBindingModel implements ICreateRoleBindingModel {
    name!: string;

    constructor(data?: ICreateRoleBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): CreateRoleBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        return data; 
    }

    clone(): CreateRoleBindingModel {
        const json = this.toJSON();
        let result = new CreateRoleBindingModel();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleBindingModel {
    name: string;
}

export class ChangePasswordBindingModel implements IChangePasswordBindingModel {
    oldPassword!: string;
    newPassword!: string;
    confirmPassword!: string;

    constructor(data?: IChangePasswordBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["OldPassword"];
            this.newPassword = _data["NewPassword"];
            this.confirmPassword = _data["ConfirmPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OldPassword"] = this.oldPassword;
        data["NewPassword"] = this.newPassword;
        data["ConfirmPassword"] = this.confirmPassword;
        return data; 
    }

    clone(): ChangePasswordBindingModel {
        const json = this.toJSON();
        let result = new ChangePasswordBindingModel();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordBindingModel {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export class EditUserModel implements IEditUserModel {
    firstName!: string;
    lastName!: string;
    mobileNumber!: string;
    userId?: string | undefined;

    constructor(data?: IEditUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.mobileNumber = _data["MobileNumber"];
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): EditUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["MobileNumber"] = this.mobileNumber;
        data["UserId"] = this.userId;
        return data; 
    }

    clone(): EditUserModel {
        const json = this.toJSON();
        let result = new EditUserModel();
        result.init(json);
        return result;
    }
}

export interface IEditUserModel {
    firstName: string;
    lastName: string;
    mobileNumber: string;
    userId?: string | undefined;
}

export class IndividualConsigneeReturnModel implements IIndividualConsigneeReturnModel {
    primaryUserEmailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    customerCode?: string | undefined;
    tRN?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    parish?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    mobilePhoneNumber?: string | undefined;

    constructor(data?: IIndividualConsigneeReturnModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryUserEmailAddress = _data["PrimaryUserEmailAddress"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.customerCode = _data["CustomerCode"];
            this.tRN = _data["TRN"];
            this.addressLine1 = _data["AddressLine1"];
            this.addressLine2 = _data["AddressLine2"];
            this.addressLine3 = _data["AddressLine3"];
            this.parish = _data["Parish"];
            this.postalCode = _data["PostalCode"];
            this.country = _data["Country"];
            this.mobilePhoneNumber = _data["MobilePhoneNumber"];
        }
    }

    static fromJS(data: any): IndividualConsigneeReturnModel {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualConsigneeReturnModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PrimaryUserEmailAddress"] = this.primaryUserEmailAddress;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["CustomerCode"] = this.customerCode;
        data["TRN"] = this.tRN;
        data["AddressLine1"] = this.addressLine1;
        data["AddressLine2"] = this.addressLine2;
        data["AddressLine3"] = this.addressLine3;
        data["Parish"] = this.parish;
        data["PostalCode"] = this.postalCode;
        data["Country"] = this.country;
        data["MobilePhoneNumber"] = this.mobilePhoneNumber;
        return data; 
    }

    clone(): IndividualConsigneeReturnModel {
        const json = this.toJSON();
        let result = new IndividualConsigneeReturnModel();
        result.init(json);
        return result;
    }
}

export interface IIndividualConsigneeReturnModel {
    primaryUserEmailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    customerCode?: string | undefined;
    tRN?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    parish?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    mobilePhoneNumber?: string | undefined;
}

export class IndividualConsigneePartialUpdateModel1 implements IIndividualConsigneePartialUpdateModel1 {
    firstName!: string;
    lastName!: string;
    tRN!: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    parish?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    customerCode?: string | undefined;

    constructor(data?: IIndividualConsigneePartialUpdateModel1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.tRN = _data["TRN"];
            this.addressLine1 = _data["AddressLine1"];
            this.addressLine2 = _data["AddressLine2"];
            this.parish = _data["Parish"];
            this.mobilePhoneNumber = _data["MobilePhoneNumber"];
            this.customerCode = _data["CustomerCode"];
        }
    }

    static fromJS(data: any): IndividualConsigneePartialUpdateModel1 {
        data = typeof data === 'object' ? data : {};
        let result = new IndividualConsigneePartialUpdateModel1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["TRN"] = this.tRN;
        data["AddressLine1"] = this.addressLine1;
        data["AddressLine2"] = this.addressLine2;
        data["Parish"] = this.parish;
        data["MobilePhoneNumber"] = this.mobilePhoneNumber;
        data["CustomerCode"] = this.customerCode;
        return data; 
    }

    clone(): IndividualConsigneePartialUpdateModel1 {
        const json = this.toJSON();
        let result = new IndividualConsigneePartialUpdateModel1();
        result.init(json);
        return result;
    }
}

export interface IIndividualConsigneePartialUpdateModel1 {
    firstName: string;
    lastName: string;
    tRN: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    parish?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    customerCode?: string | undefined;
}

export enum CompanyRegistrationModelEmailConfirmationMethod {
    None = "None",
    Url = "Url",
    Token = "Token",
}

export enum IndividualRegistrationEmailConfirmationMethod {
    None = "None",
    Url = "Url",
    Token = "Token",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}